(function() {
    'use strict';
 
a3_pilot_reports.factory('AirportHotelFactory',AirportHotelFactory);
 
    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name AirportHotelFactory
    * @description 
    *   Add, Update, Delete and Get Airport Hotels.
    * @ngInject
    */
function AirportHotelFactory(GenericService){
    
        /**
        * Initialize the AirportHotel
        * @memberof AirportHotelFactory
        */
		function Airport() {
            this.Iata=null;
            this.Hotels=null;
        }
        
		var objType = 'airportHotels';
		var objCallback = Airport; 

		var service = 
		{  
			fromObjectList : fromObjectList,
			getAirportHotelsFromStorage : getAirportHotelsFromStorage,
			setAirportHotelsToStorage : setAirportHotelsToStorage,
            clearAirportHotelsFromStorage : clearAirportHotelsFromStorage,
            getAirportHotels: getAirportHotels,
            upsertAirportHotels : upsertAirportHotels
		};

        /**
         * Extend an array of Objects from the default airportHotel Object
         * @memberof AirportHotelFactory
         * @param {Array} objList  an Array Of airportHotel
         * @returns {Array} airportHotel
         */
		function fromObjectList(objList) {
			return GenericService.fromObjectList(objList,objCallback);
		}
    
        /**
         * Get airportHotels
         * @memberof AirportHotelFactory
         * @returns {Array} airportHotels
         */
		function getAirportHotelsFromStorage() {
			return GenericService.list(objType,objCallback);
		}
    
        /**
         * Save airportHotels to storage
         * @memberof AirportHotelFactory
         * @param {Array} airportHotels A list of AirportHotels
         */
		function setAirportHotelsToStorage(airportHotels) {
			GenericService.saveAll(airportHotels,objType,objCallback);
		}
    
        /**
         * Remove the airportHotels of  the local storage
         * @memberof AirportHotelFactory
         */
		function clearAirportHotelsFromStorage() {
			GenericService.removeAll(objType,objCallback);
        }
    
        /**
         * Get the Hotels for a given airport
         * @memberof AirportHotelFactory
         */
		function getAirportHotels(airportIata, fltDate) {
            var all = this.getAirportHotelsFromStorage();
            if (!all) return null;
            var airport = all.filter(function(item){return item.Iata == airportIata});
            if (!airport || airport.length == 0) return null;
            
            //for each airport hotel
            //from all available hotel priorities, find the one matching the active period 
            angular.forEach(airport[0].Hotels, function(hotel) 
            {
                var fltActiveHotels = hotel && hotel.HotelPriorities ? hotel.HotelPriorities.filter(function(item){return fltDate >= item.ActiveBegin && fltDate <= item.ActiveEnd}) : [];               
                if (!fltActiveHotels || fltActiveHotels.length == 0) return ; //hotel inactive in FltDate - ActivePriority will be undefined for this hotel
                hotel.ActivePriority = fltActiveHotels[0].PriorityNo; //set the ActivePriority field for the hotel to be displayed in UI
            });
            

            //we expect a single airport item per iata
            return airport[0];
            //return GenericService.fromObjectList(airport[0].Hotels, Hotel);
        }

         /**
         *  Upsert aircraft hotels
         * @memberof AirportHotelFactory
         */
             function upsertAirportHotels(airportHotels) {
                var newHotels = airportHotels.map(x => x.Iata);
                var hotelsLS = this.getAirportHotelsFromStorage();
                hotelsLS = hotelsLS.filter(x => !newHotels.includes(x.Iata));
                var updatedHotelsList = hotelsLS.concat(airportHotels);
                setAirportHotelsToStorage(updatedHotelsList);
            }
        
	return service;
	}

 
 })();   